export default "__VITE_ASSET__de11df7a__"